import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';

import templateMessages from './useValidationMessage.messages';

type ValidationMessageType = 'invalid' | 'required';

const useValidationMessage = (messages: Record<string, MessageDescriptor>) => {
  const { formatMessage } = useIntl();

  const getTemplateKey = (type: ValidationMessageType): string =>
    ({
      invalid: 'invalidValidationError',
      required: 'requiredValidationError',
    })[type];

  const msg = ({ key, type }: { key: string; type: ValidationMessageType }) => {
    return formatMessage(templateMessages[getTemplateKey(type)], {
      field: formatMessage(messages[key]),
    });
  };

  return { getTemplateKey, msg };
};

export default useValidationMessage;
